export default __webpack_public_path__ + "static/cats-f0d92f53cd158a14c0a2c9c8ba31e004.png";